"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationTarget = void 0;
exports.NavigationTarget = {
    ContentView: 'contentView',
    ContentEdit: 'contentEdit',
    ContentList: 'contentList',
    SpaceView: 'spaceView',
    Module: 'module',
    UserProfile: 'userProfile',
    Dashboard: 'dashboard',
    Issue: 'issue',
    ProjectSettingsDetails: 'projectSettingsDetails'
};
